import React from 'react'
import Inicio from "../paginas/Inicio"
import Iknow from "../paginas/Iknow"
import About from "../paginas/About"
import MysProyects from "../paginas/MysProyects"
import Cabecera from "../componentes/Cabecera"
import Izquierda from "../componentes/Izquierda"
import Derecha from "../componentes/Derecha"
import ContactMe from "../paginas/ContactMe"
import Pie from "../componentes/Pie"

const English = () => {
  return (
    <div className=' bg-slate-800'>
        <Cabecera/>
        <div className='flex w-full '>
            <div className='w-1/12 '>
                <Izquierda/>
            </div>
            <div className='w-10/12 '>
                <div><Inicio /></div>
                <div><About/></div>
                <div><Iknow/></div>
                <div><MysProyects/></div>
                <div><ContactMe/></div>
                
            </div>
            <div className='w-1/12 justify-center flex items-center h-screen '>
                <Derecha/>
            </div>

        </div>
        <Pie/>
    </div>
  )
}

export default English